"use client";

import * as React from "react";

import { Maximize2, Minimize2 } from "lucide-react";

import { ToolbarButton } from "./toolbar";

export function FullscreenToolbarButton(props: { isFullscreen?: boolean; onFullscreenChange?: () => void }) {
  return (
    <ToolbarButton
      pressed={props.isFullscreen}
      tooltip={props.isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
      onClick={() => props && props.onFullscreenChange && props.onFullscreenChange()}
    >
      {props.isFullscreen === true ? <Minimize2 /> : <Maximize2 />}
    </ToolbarButton>
  );
}
